import React from 'react';
import { Field } from 'redux-form';
import { renderTextField, requiredValidator, renderSelect, renderDatePicker } from 'utils/formHelper';

export default class PersonalDetails extends React.Component {
  render = () => {
    return (
      <div>
        <div className='form-row' >
          <Field
            name={`${this.props.person}.fullName`}
            component={renderTextField}
            label='Full Name'
            validate={requiredValidator}
          />
          <Field
            name={`${this.props.person}.title`}
            component={renderSelect}
            label='title'
            options={['Director', 'Partner', 'Sole Proprietor', 'Guarantor']}
            validate={requiredValidator}
          />
          <Field
            name={`${this.props.person}.dependents`}
            component={renderTextField}
            label='No. of dependants'
          />
          <Field
            name={`${this.props.person}.homePhone`}
            component={renderTextField}
            label='Home phone'
          />
          <Field
            name={`${this.props.person}.email`}
            component={renderTextField}
            label='Email'
          />
          <Field
            name={`${this.props.person}.dateOfBirth`}
            component={renderDatePicker}
            label='Date of birth'
          />
          <Field
            name={`${this.props.person}.maritalStatus`}
            options={['', 'Single', 'Married', 'Separated', 'Widowed', 'Divorced']}
            component={renderSelect}
            label='Martial status'
          />
          <Field
            name={`${this.props.person}.residentialStatus`}
            options={['', 'Owner occupied', 'Renting', 'Boarding', 'Other']}
            component={renderSelect}
            label='Residential status'
          />
          <Field
            name={`${this.props.person}.residentialAddress.streetAddress`}
            component={renderTextField}
            label='Street address'
          />
          <Field
            name={`${this.props.person}.residentialAddress.city`}
            component={renderTextField}
            label='City'
          />
          <Field
            name={`${this.props.person}.residentialAddress.state`}
            component={renderTextField}
            label='State'
          />
          <Field
            name={`${this.props.person}.residentialAddress.postcode`}
            component={renderTextField}
            label='Postcode'
          />
          <Field
            name={`${this.props.person}.otherResidentialStatus`}
            component={renderTextField}
            label='Other residential status'
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Applications/PersonalDetails.js